import { useState, useCallback } from 'react';
import { d211Api, FD110 } from '../../../services/d211Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for the master record */
  const resolveAllNames = useCallback(async (data: Partial<FD110>) => {
    const entries: [string, string, string][] = [
      ['supplier', 'supplier', data.fd110_12 || ''],       // 分包商
      ['currency', 'currency', data.fd110_19 || ''],       // 幣別
      ['paymentTerms', 'paymentTerms', data.fd110_151 || ''],  // 付款條件
      ['tradeTerms', 'tradeTerms', data.fd110_141 || ''],      // 交易條件
      ['packing', 'packing', data.fd110_16 || ''],             // 包裝方式
      ['qcPerson', 'employee', data.fd110_30 || ''],           // QC人員
      ['buyer', 'employee', data.fd110_31 || ''],              // 採購人員
      ['receivingCo', 'supplier', data.fd110_33 || ''],        // 收貨公司
      ['entryPerson', 'employee', data.fd110_91 || ''],        // 輸單人員
      ['remarkTemplate', 'remarkTemplate', data.fd110_421 || ''], // 備註代號
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        d211Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await d211Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, setNames, resolveAllNames, resolveSingleName, clearNames };
}
